import Pagination, {PaginationProps} from '@mui/material/Pagination';
import PaginationItem, {PaginationItemProps} from '@mui/material/PaginationItem';

import {styled} from '@mui/material/styles';

export const CPagination = styled(Pagination)<PaginationProps>(
  (/* { theme } */) => ({
  }),
);

export const CPaginationItem = styled(PaginationItem)<PaginationItemProps>(
  (/* { theme } */) => ({
  }),
);

